import TmpIconCustom from "../TmpIconCustom/TmpIconCustom";
import TmpSpinnerCustom from "../TmpSpinnerCustom/TmpSpinnerCustom";
import { Button, ButtonContent } from "./Style";
import { style } from "./StyleType";

interface TmpButtonCustomProps {
    type: "primary" | "secondary";
    typeButton: "submit" | "button";
    size: "sm" | "lg";
    disabled?: boolean;
    widthFull?: boolean;
    loading?: boolean;
    startIcon?: any;
    id?: string;
    handleClick: () => void;
    ariaLabel?: string;
    children: React.ReactNode;
}

export default function TmpButtonCustom(props: TmpButtonCustomProps) {


    // Events
    const _handleClick = () => {
        props.handleClick();
    };

    // Passing style props to styled component
    Button.defaultProps = style;
    // Spinner.defaultProps = style;

    return (
        <ButtonContent>
            <Button
                id={props.id}
                className={"tmp-button"}
                type={props.typeButton}
                variant={props.type}
                size={props.size}
                disabled={props.disabled}
                aria-disabled={props.disabled}
                loading={props.loading !== undefined && props.loading === true ? "true" : undefined}
                data-testid="button"
                onClick={_handleClick}
                aria-label={props.ariaLabel}
                startIcon={props.startIcon != null ? true : false}
                widthFull={props.widthFull ? true : false}
            >
                {props.loading && <TmpSpinnerCustom />}
                
                <div className="label">
                    {props.startIcon && (
                        <span className="icon">
                            <TmpIconCustom size="sm" icon={props.startIcon} />
                        </span>
                    )}

                    {props.children}
                </div>
            </Button>
        </ButtonContent>
    );

}